import { render } from "./MdCellActions.vue?vue&type=template&id=4272fe04&scoped=true"
import script from "./MdCellActions.vue?vue&type=script&lang=js"
export * from "./MdCellActions.vue?vue&type=script&lang=js"

import "./MdCellActions.vue?vue&type=style&index=0&id=4272fe04&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4272fe04"]])

export default __exports__